<div class="menu-container" [hidden]="!menuOpen">
	<div class="menu" (keydown)="keyDown" #menu>
		<ng-content (keydown)="keyDown"></ng-content>
	</div>
</div>
